// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_row * bcSfFilterConfig.custom.rows_number,
        loadProductFirst: true,
        sortingList: ['manual', 'price-ascending', 'price-descending', 'title-descending','title-ascending', 'created-ascending', 'created-descending', 'sale-descending']
    },
    label: {
        sorting: {
            'manual' : 'Featured',
            'price-ascending' : '£ Low to High', 
            'price-descending' : '£ High to Low',
            'title-descending': 'Z-A',
            'title-ascending': 'A-Z',
            'created-ascending': 'Oldest to Newest', 
            'created-descending': 'Newest to Oldest',
            'sale-descending': '% Off'
        }
    }
};

var bcSfFilterTemplate = {
    'vendorHtml': '<p class="product-list-item-vendor"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></p>',

    'productGridItemHtml':  '<article class="product-list-item" id="product-list-item-{{itemId}}" data-product-id="{{itemId}}">' +
                                '<figure class="product-list-item-thumbnail {{itemFlipImageClass}}" data-url="{{itemUrl}}" style="{{itemFlipImageUrl}}">' +
                                    '<a href="{{itemUrl}}"><img src="{{itemThumbUrl}}" /></a>' +
                                    '{{itemQuickView}}' +
                                    '{{itemLabel}}' +
                                '</figure>' +
                                '<div class="product-list-item-details">' +
                                    '{{itemVendor}}' +
                                    '<h2 class="product-list-item-title"><a href="{{itemUrl}}">{{itemTitle}}</a></h2>' +
                                    '<p class="product-list-item-price">{{itemPrice}}</p>' +
                                '</div>' +
                            '</article>',

    'previousHtml': '<li class="previous"><a href="{{itemUrl}}">&#xe601;</a></li>',
    'nextHtml': '<li class="next"><a href="{{itemUrl}}">&#xe600;</a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><a href="" title="">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="ellipsis">{{itemTitle}}</li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    'sortingHtml': '<span class="selected-text"></span><select>{{sortingItems}}</select>',
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> <span class="divider">/</span> <a href="/collections">' + bcSfFilterConfig.label.breadcrumb_header + '</a> <span class="divider">/</span> <span>{{itemSelected}}</span>'
};

// Build Product List
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    // Prepare data
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;
    var hasFlipImage = bcSfFilterConfig.custom.product_hover == 'image-flip' ? true : false;

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;    

    // Get First Variant
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') {
            firstVariant = paramVariant[0];
        }
    }

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0], '208x208') : bcSfFilterConfig.general.no_image_url;
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1], '208x208') : itemThumbUrl;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Flip Image
    itemHtml = itemHtml.replace(/{{itemFlipImageClass}}/g, hasFlipImage ? 'has-secondary-image' : '');
    itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, hasFlipImage ? 'background-image:url(' + itemFlipImageUrl + ')' : '');

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.product_hover == 'quick-shop') {
        itemQuickViewHtml += '<script type="application/json" data-product-json>{{itemProductJson}}</script>';
        itemQuickViewHtml += '<script type="application/json" data-product-settings-json>';
        itemQuickViewHtml += '{';
        itemQuickViewHtml += '"addToCartText": ' + JSON.stringify(bcSfFilterConfig.label.add_to_cart) + ',';
        itemQuickViewHtml += '"enableHistory": ' + JSON.stringify(bcSfFilterConfig.label.enable_history) + ',';
        itemQuickViewHtml += '"imageZoom": false,';
        itemQuickViewHtml += '"linkedOptions": false,';
        itemQuickViewHtml += '"processingText": ' + JSON.stringify(bcSfFilterConfig.label.processing) + ',';
        itemQuickViewHtml += '"ajaxAddProduct": true,';
        itemQuickViewHtml += '"setQuantityText": ' + JSON.stringify(bcSfFilterConfig.label.set_quantity) + ',';
        itemQuickViewHtml += '"soldOutText": ' + JSON.stringify(bcSfFilterConfig.label.sold_out) + ',';
        itemQuickViewHtml += '"unavailableText": ' + JSON.stringify(bcSfFilterConfig.label.unavailable) + ',';
        itemQuickViewHtml += '}';
        itemQuickViewHtml += '</script>';
        itemQuickViewHtml += '<span class="quick-shop-modal-trigger" data-product-handle="{{itemHandle}}" data-product-id="{{itemId}" data-variant-id="' + firstVariant['id'] + '" data-vendor-url="{{itemVendor}}">' + bcSfFilterConfig.label.quick_shop + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Label
    var itemLabelHtml = '';
    if (bcSfFilterConfig.custom.product_badges) {
        if (soldOut) {
            var iconClass = bcSfFilterConfig.custom.product_icons ? 'product-icons' : '';
            itemLabelHtml += '<span class="product-list-item-unavailable ' + iconClass + ' " data-title="' + bcSfFilterConfig.label.sold_out + '"></span>';            
        } else {
            if (onSale) {
                itemLabelHtml += '<span class="product-list-item-on-sale ' + iconClass + '" data-title="' + bcSfFilterConfig.label.sale + '"></span>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);
    
    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_price;
    }
    itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    if (onSale) {
        itemPriceHtml += '<span class="original money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build wrapper
        paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }

    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = this.queryParams.page * this.queryParams.limit;
    jQ(this.selector.bottomPagination).find('.count').html(bcSfFilterConfig.label.showing_items + from + '-' + to + ' of ' + totalProduct);
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
          	jQ(this.selector.topSorting + ' .selected-text').html(sortingArr[this.queryParams.sort]);
        }
    }
};

// Build Breadcrumb when user select "Collection" filter option
BCSfFilter.prototype.buildBreadcrumb = function(data) {
    var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml.replace(/{{itemSelected}}/g, data);
    jQ('.breadcrumbs').html(breadcrumbHtml);
};

function BCSfFilterCallback (result) {
	bcsffilter.hideLoading();
	bcsffilter.afterGetFilterData(result, result.event_type);
};

// Request API for Filter Data
BCSfFilter.prototype.getFilterData = function (eventType) {
	var _this = this;
	_this.showLoading();
	
	// Prepare params
	var params = mergeObject({}, this.queryParams);
	params.collection_scope = parseInt(this.collectionId);
	if (eventType == "history") {
		if (History.getState().data.hasOwnProperty("param") && History.getState().data.param.hasOwnProperty("collection_scope")) {
			params.collection_scope = this.collectionId = parseInt(History.getState().data.param.collection_scope);
		} else {
			params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
		}
	}
	if (this.getSettingValue("general.availableAfterFiltering") == true) {
		params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
		params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
	} else {
		params.product_available = this.productAvailable;
		params.variant_available = this.variantAvailable;
	}
	if (typeof this.collectionTags !== "undefined" && this.collectionTags !== null) {
		params.tag = this.collectionTags[0];
	}
	params.build_filter_tree = (typeof eventType !== "undefined" && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
	params.check_cache = (this.checkExistFilterOptionParam() === false && params["page"] == 1 && params["sort"] == this.defaultSorting && params["limit"] == this.getSettingValue("general.limit")) ? true : false; // Only cache when request doest not have Refine By, "page" param equal to 1 and "sort" param equal to default sorting
	// Set data back to queryParams
	this.queryParams = params;

	this.queryParams["callback"] = "BCSfFilterCallback";
	this.queryParams["event_type"] = eventType;
	var script = document.createElement("script");
	//Set the Type
	script.type = "text/javascript";
	var timestamp = new Date().getTime();
	//Set the source to the URL the JSON Service.
	script.src = bcSfFilterConfig.shop.apiUrl + "?t=" + timestamp + "&" + jQ.param(_this.queryParams);
	script.async = true;
	script.addEventListener("error", function (e) {
		this.remove();
		// Error handling here 
		_this.showError("Oops, we cannot fetch products at this moment. Please try again later.");
	});
	//Append the script element to the HEAD section.
	document.getElementsByTagName("head")[0].appendChild(script);
	script.onload = function () {
		this.remove();
	};
};

// Customize data to suit the theme
BCSfFilter.prototype.prepareProductData = function(data) {
	for (var k in data) {
		var optionsArr = [];
		for (var i in data[k]["options_with_values"]) {
			optionsArr.push(data[k]["options_with_values"][i]["name"]);
		}
		data[k]["options"] = optionsArr;
		for (var i in data[k]["variants"]) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]["variants"][i];

		   // New API
			if (typeof variant.hasOwnProperty("merged_options")) {
				var variantOptions = variant["merged_options"];
				for (var j in variantOptions) {
				  var temp = variantOptions[j].split(":");
				  data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
				  data[k]["variants"][i]["option_" + temp[0]] = temp[1];
				  variantOptionArr.push(temp[1]);
				}
			}
			// Old API
			else {
				for (var j in variant) {
					if (j.indexOf("option_") != -1) {
					  data[k]["variants"][i]["option" + count] = variant[j];
					  variantOptionArr.push(data[k]["variants"][i][j]);
					  count ++;
					}
				}
			}
			data[k]["variants"][i]["compare_at_price"] = parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
			data[k]["variants"][i]["price"] = parseFloat(data[k]["variants"][i]["price"]) * 100;
			data[k]["variants"][i]["options"] = variantOptionArr;
		}
	}
	return data;
};